module.exports = {
    Restaurant: 'Restaurant',
    Bar: 'Bar',
    Promoter: 'Promoter',
    EventCoordinator: 'Event Coordinator',
    Bartender: 'Bartender',
    Server: 'Server',
    Contractor: 'Contractor'
}
